import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';
import i18n from 'i18n';
import { MIGRATION_STATUS } from '../../constants';

export const GET_MIGRATION_STATUS = '@PHARMACY/DATA_UPLOAD_GET_MIGRATION_STATUS';
export const GET_MIGRATION_STATUS_SUCCESS = '@PHARMACY/DATA_UPLOAD_GET_MIGRATION_STATUS_SUCCESS';

export const START_DATA_MIGRATION = '@PHARMACY/DATA_UPLOAD_START_DATA_MIGRATION';
export const END_DATA_MIGRATION = '@PHARMACY/DATA_UPLOAD_END_DATA_MIGRATION';

export const START_DISPENSE_REFRESH = '@PHARMACY/DATA_UPLOAD_START_DISPENSE_REFRESH';
export const END_DISPENSE_REFRESH = '@PHARMACY/DATA_UPLOAD_END_DISPENSE_REFRESH';

export const START_REQUEST_SYNC = '@PHARMACY/START_REQUEST_SYNC';
export const END_REQUEST_SYNC = '@PHARMACY/END_REQUEST_SYNC';

export function startDataMigration(pharmacyId) {
  return (dispatch) => {
    // Check previous migration status
    HttpService.get(`/api/pharmacies/${pharmacyId}/migration-status`)
      .then((resp) => {
        if (resp.migrationStatus === MIGRATION_STATUS.NOT_STARTED) {
          dispatch({ type: START_DATA_MIGRATION });
          // Start migration if pharmacy haven't been migrated before
          HttpService.put(`/api/pharmacies/${pharmacyId}/data-migrate`)
            .then(() => {
              dispatch(
                AppActions.showMessage({
                  message: 'pharmacy:DATA_UPLOAD_DATA_MIGRATION_MESSAGE',
                  autoHideDuration: 4000,
                  anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                  },
                  variant: 'success',
                }),
              );
            })
            .catch((err) => {
              const { errorMessages, errorTitle } = parseError(err);
              dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
            })
            .finally(() => {
              dispatch({ type: END_DATA_MIGRATION });
            });
        } else if (
          resp.migrationStatus === MIGRATION_STATUS.COMPLETED ||
          resp.migrationStatus === MIGRATION_STATUS.FAILED
        ) {
          // Show confirm dialog to force migrate
          dispatch(
            AppActions.createDialogMessage(
              'info',
              'Info',
              {
                message: 'pharmacy:MIGRATION_PROCESS_COMPLETED',
                options: {
                  code: 'code',
                  medication: 'medication',
                },
              },
              {
                dialogId: 'MIGRATION_CONFIRM_FORCE_UPDATE',
                options: {
                  buttons: [
                    {
                      label: i18n.t('NO'),
                    },
                    {
                      label: i18n.t('YES'),
                      color: 'primary',
                      variant: 'contained',
                    },
                  ],
                },
                callback: (label) => {
                  if (label === i18n.t('YES')) {
                    dispatch({ type: START_DATA_MIGRATION });
                    HttpService.put(`/api/pharmacies/${pharmacyId}/data-migrate?forcedUpdate=true`)
                      .then(() => {
                        dispatch(
                          AppActions.showMessage({
                            message:
                              'Reset the pharmacy database started, please wait to process to reset the database complete',
                            autoHideDuration: 4000,
                            anchorOrigin: {
                              vertical: 'top',
                              horizontal: 'right',
                            },
                            variant: 'success',
                          }),
                        );
                      })
                      .catch((err) => {
                        const { errorMessages, errorTitle } = parseError(err);
                        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
                      })
                      .finally(() => {
                        dispatch({ type: END_DATA_MIGRATION });
                      });
                  }
                  dispatch(AppActions.closeDialogMessage('MIGRATION_CONFIRM_FORCE_UPDATE'));
                },
              },
            ),
          );
        } else if (resp.migrationStatus === MIGRATION_STATUS.RUNNING) {
          // Show error message if another migration is running
          dispatch(
            AppActions.createDialogMessage('error', 'Desktop Migration', 'pharmacy:MIGRATION_PROCESS_IS_RUNNING'),
          );
        }
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
}

export function startDispenseRefresh(pharmacyId) {
  return (dispatch) => {
    dispatch({ type: START_DISPENSE_REFRESH });
    HttpService.put(`/api/pharmacies/${pharmacyId}/refresh-dispense`, {
      loopbackDays: 365,
      clearCache: true,
    })
      .then((resp) => {
        dispatch(
          AppActions.showMessage({
            message: resp?.message,
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
        dispatch({ type: END_DISPENSE_REFRESH });
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: END_DISPENSE_REFRESH });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
}

export function requestSyncData(pharmacyId) {
  return (dispatch) => {
    dispatch({ type: START_REQUEST_SYNC });
    HttpService.put(`/api/pharmacies/${pharmacyId}/sync`)
      .then(() => {
        dispatch({ type: END_REQUEST_SYNC });
        dispatch(
          AppActions.showMessage({
            message: 'pharmacy:REQUEST_SYNC_MESSAGE',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: END_REQUEST_SYNC });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
}
